import React, { useState, useEffect } from 'react';
import { Layout, Form, Input, Button, notification, Modal as ModalAntd } from 'antd';
import Logo from '../assets/img/png/Logo-icontec.png';

import { recoverPassApi, recoverCodeApi } from '../api/user';

import './Recover.scss';

const { success } = ModalAntd;

export default function Recover(props) {
	const { match } = props;
	const { Content } = Layout;
	const codigo = match.params.cod;

	const [recoverData, setRecoverData] = useState([]);
	const [validCode, setValidCode] = useState(false);

	//
	useEffect(() => {
		recoverPassApi(codigo).then((response) => {
			if (response.estado === 'OK') {
				setRecoverData(response.result);
				setValidCode(true);
			} else {
				setRecoverData([]);
				setValidCode(false);
			}
		});
	}, []);

	return (
		<Layout className="recover">
			<Content className="recover__content">
				<h1 className="recover__content-logo">
					<img src={Logo} alt="Huella de Confianza" />
				</h1>
				<RecoverPassword codigo={codigo} recoverData={recoverData} />
			</Content>
		</Layout>
	);
}

function RecoverPassword(props) {
	const { codigo, recoverData } = props;
	const [isLoading, setIsLoading] = useState(false);
	const [inputs, setInputs] = useState({ codigo: '' });

	const GoHome = () => {
		window.location.href = '/';
	};

	const recoverPass = async (e) => {
		e.preventDefault();
		setIsLoading(true);
		if (!inputs.codigo) {
			notification['error']({
				message: 'Debe ingresar el código',
			});
			setIsLoading(false);
		} else {
			const result = await recoverCodeApi(codigo, inputs);

			if (result.estado === 'Error') {
				notification['error']({
					message: result.result,
				});
				setInputs({ codigo: '' });
				setIsLoading(false);
			} else {
				success({
					title: 'Código Validado',
					content: result.result,
					onOk() {
						GoHome();
					},
				});

				setIsLoading(false);
			}
		}
	};

	const changeForm = (e) => {
		setInputs({
			...inputs,
			[e.target.name]: e.target.value,
		});
	};

	if (recoverData.estado === undefined) {
		return (
			<div className="content">
				<h3 className="content__head-error">Código Inválido</h3>
				<div className="content__content">
					El enlace al que desea ingresar es inválido, por favor vuelva a realizar la solicitud
				</div>
				<div className="content__return">
					<a onClick={GoHome}>Ir al Inicio</a>
				</div>
			</div>
		);
	} else if (recoverData.estado === 1) {
		return (
			<div className="content">
				<h3 className="content__head-error">{recoverData.usuario}</h3>
				<div className="content__content">
					El enlace que esta intentando registrar ya fue usado, o fue inactivado por una nueva solicitud, por
					favor vuelva a realizar la solicitud
				</div>
				<div className="content__return">
					<a onClick={GoHome}>Ir al Inicio</a>
				</div>
			</div>
		);
	} else {
		return (
			<div className="content">
				<div className="content__content">
					<h3 className="content__head-success">{recoverData.usuario}</h3>
					<div className="content__content">
						Para recuperar su contraseña por favor digite el código que fue enviado a su correo electrónico
					</div>
					<Form className="content__form" onChange={changeForm} onSubmit={recoverPass}>
						<Form.Item>
							<Input
								type="text"
								name="codigo"
								placeholder="Ingrese el código"
								className="content__form__input"
								value={inputs.codigo}
							/>
						</Form.Item>

						<Form.Item>
							<Button htmlType="submit" className="content__form__button" loading={isLoading}>
								Registrar Código
							</Button>
						</Form.Item>
					</Form>
				</div>
			</div>
		);
	}
}
